import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Elevation from './Elevation';
import ClientProvider from './client';
export default createDemo(import.meta.url, Elevation, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/paper/demos/elevation/Elevation.tsx",
    "fileName": "Elevation.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Grid from '@mui/material/Grid';\nimport Paper from '@mui/material/Paper';\nimport Box from '@mui/material/Box';\nimport { createTheme, ThemeProvider, styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  ...theme.typography.body2,\n  textAlign: 'center',\n  color: theme.palette.text.secondary,\n  height: 60,\n  lineHeight: '60px',\n}));\n\nconst darkTheme = createTheme({ palette: { mode: 'dark' } });\nconst lightTheme = createTheme({ palette: { mode: 'light' } });\n\nexport default function Elevation() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container spacing={2}>\n        {[lightTheme, darkTheme].map((theme, index) => (\n          <Grid key={index} size={6}>\n            <ThemeProvider theme={theme}>\n              <Box\n                sx={{\n                  p: 2,\n                  borderRadius: 2,\n                  bgcolor: 'background.default',\n                  display: 'grid',\n                  gridTemplateColumns: { md: '1fr 1fr' },\n                  gap: 2,\n                }}\n              >\n                {[0, 1, 2, 3, 4, 6, 8, 12, 16, 24].map((elevation) => (\n                  <Item key={elevation} elevation={elevation}>\n                    {`elevation=${elevation}`}\n                  </Item>\n                ))}\n              </Box>\n            </ThemeProvider>\n          </Grid>\n        ))}\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 46,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Grid from '@mui/material/Grid';\nimport Paper from '@mui/material/Paper';\nimport Box from '@mui/material/Box';\nimport { createTheme, ThemeProvider, styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  ...theme.typography.body2,\n  textAlign: 'center',\n  color: theme.palette.text.secondary,\n  height: 60,\n  lineHeight: '60px',\n}));\n\nconst darkTheme = createTheme({ palette: { mode: 'dark' } });\nconst lightTheme = createTheme({ palette: { mode: 'light' } });\n\nexport default function Elevation() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Grid container spacing={2}>\n        {[lightTheme, darkTheme].map((theme, index) => (\n          <Grid key={index} size={6}>\n            <ThemeProvider theme={theme}>\n              <Box\n                sx={{\n                  p: 2,\n                  borderRadius: 2,\n                  bgcolor: 'background.default',\n                  display: 'grid',\n                  gridTemplateColumns: { md: '1fr 1fr' },\n                  gap: 2,\n                }}\n              >\n                {[0, 1, 2, 3, 4, 6, 8, 12, 16, 24].map((elevation) => (\n                  <Item key={elevation} elevation={elevation}>\n                    {`elevation=${elevation}`}\n                  </Item>\n                ))}\n              </Box>\n            </ThemeProvider>\n          </Grid>\n        ))}\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 46,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Grid",
      "@mui/material/Paper",
      "@mui/material/Box",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
